import { Stack } from "@altimateai/lego";
import { PAGE_SIZE_OPTIONS } from "@/pages/query/constants";
import { Label, NativeSelect, Typography } from "@altimateai/lego";
import { Graph } from "@/pages/query/Graph";
import { FC, useState } from "react";
import { DbtJobRunItem } from "@/pages/query/types";

interface CommonTaskRunsGraphProps {
  graphData?: DbtJobRunItem[];
  isLoading?: boolean;
}

export const CommonTaskRunsGraph: FC<CommonTaskRunsGraphProps> = ({ graphData, isLoading }) => {
  const [graphSize, setGraphSize] = useState(PAGE_SIZE_OPTIONS[0].value);

  return (
    <>
      <Stack align="center">
        <Typography variant={"section-heading"}>Runs Cost</Typography>
        <div className="spacer" />
        {(graphData?.length || 0) > Number(PAGE_SIZE_OPTIONS[0].value) && (
          <Stack direction={"row"} align={"center"} gap={"md"}>
            <Label className={"al-m-0"}>Show Runs:</Label>
            <NativeSelect
              className={"al-min-w-36"}
              variant={"outline"}
              options={PAGE_SIZE_OPTIONS}
              value={graphSize}
              onChange={setGraphSize}
            />
          </Stack>
        )}
      </Stack>
      <Graph
        isLoading={isLoading}
        data={graphData?.slice(0, Number(graphSize)) ?? []}
        annotationEnabled
        setSelectedRun={() => {}}
      />
    </>
  );
};
